import { CheckableInput_default } from "./chunk-W4WFEW7W.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Checkbox/Checkbox.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var CHECKBOX_CLASSNAME_MAP = {};
var Checkbox = forwardRef((_a, ref) => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */jsx(CheckableInput_default, __spreadValues({
    ref,
    type: "checkbox",
    className: clsx("pd:checkbox", className)
  }, rest));
});
var Checkbox_default = Checkbox;
export { CHECKBOX_CLASSNAME_MAP, Checkbox_default };